export default __webpack_public_path__ + "static/media/anatomy-of-a-seed@3x.405c1ed1.png";